// Shared motion tokens. CSS transitions use the `linear()` spring curves below
// (sampled from a damped spring), and JS animations use the matching
// stiffness/damping pairs so CSS and motion/react feel like one system.
// See DESIGN.md › Motion and feedback.

export const springs = {
  // Hover lifts and small local state changes. ~7% overshoot, settles in ~660ms.
  gentle: { type: 'spring', stiffness: 220, damping: 19, mass: 1 },
  // Presses, toggles and chips. ~2% overshoot, settles in ~380ms.
  snappy: { type: 'spring', stiffness: 420, damping: 32, mass: 1 },
  // Reveals that should feel alive: hover cards, blossoms. ~17% overshoot.
  bloom: { type: 'spring', stiffness: 180, damping: 13, mass: 1 },
} as const;

export const easings = {
  gentle:
    'linear(0, 0.061, 0.188, 0.354, 0.517, 0.673, 0.8, 0.904, 0.977, 1.028, 1.056, 1.069, 1.071, 1.065, 1.054, 1.043, 1.031, 1.021, 1.012, 1.005, 1, 0.997, 0.996, 0.995, 0.995, 0.996, 0.996, 0.997, 1)',
  snappy:
    'linear(0, 0.043, 0.127, 0.241, 0.364, 0.485, 0.588, 0.687, 0.77, 0.834, 0.889, 0.931, 0.962, 0.984, 0.999, 1.009, 1.015, 1.018, 1.018, 1.017, 1.016, 1.014, 1.011, 1.009, 1.007, 1.006, 1.004, 1.003, 1)',
  bloom:
    'linear(0, 0.092, 0.287, 0.53, 0.755, 0.944, 1.073, 1.148, 1.174, 1.164, 1.132, 1.091, 1.05, 1.016, 0.991, 0.976, 0.97, 0.971, 0.976, 0.983, 0.99, 0.996, 1.001, 1.004, 1.005, 1.005, 1.004, 1.003, 1)',
  // Plain fades and colour changes should not bounce.
  calm: 'cubic-bezier(.2, .8, .2, 1)',
} as const;

export const durations = {
  gentle: 660,
  snappy: 380,
  bloom: 910,
  calm: 280,
} as const;

export const reducedMotionQuery = '@media (prefers-reduced-motion: reduce)';

export function prefersReducedMotion(): boolean {
  try {
    return window.matchMedia?.('(prefers-reduced-motion: reduce)')?.matches ?? false;
  } catch {
    return false;
  }
}
